import store from '@polleverywhere/redux'
import store2 from 'store2'
import { slice as appSlice } from '../../slices/app'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import { getBackboneAppState } from '../../states/participant/reduxLink'
import { html } from 'lit-html'

function returnToRequestedOrDefault () {
  const returnTo = store2.session.remove('loginReturnTo')

  // If we have somewhere specified return to, try to go there (fallback to default)
  if (returnTo) {
    const participantState = getBackboneAppState()
    if (participantState && returnTo.type && returnTo.participantKey) {
      participantState.showIndividualActivity(returnTo.type, returnTo.participantKey)
    } else if (participantState && returnTo.login) {
      participantState.joinPresenterSession(returnTo.login)
    } else {
      store.dispatch(appSlice.pageUpdatedToDefault())
    }
  } else {
    store.dispatch(appSlice.pageUpdatedToDefault())
  }
}

export default async function login (state, appOptions) {
  // If we're already logged in, go back or default
  if (profileSlice.selectIsLoggedIn(store.getState())) {
    return returnToRequestedOrDefault()
  }

  await import(/* webpackChunkName: 'login' */ '../../components/login')

  return html`<pec-login-page></pec-login-page>`
}
